var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3723_88419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 2H14C14.1767 2.00026 14.3461 2.07065 14.471 2.19571C14.5959 2.32077 14.666 2.49027 14.666 2.667V13.333C14.666 13.5097 14.5959 13.6792 14.471 13.8043C14.3461 13.9293 14.1767 13.9997 14 14H2.00001C1.91238 14.0001 1.82559 13.983 1.7446 13.9495C1.66362 13.916 1.59004 13.8669 1.52807 13.8049C1.46611 13.743 1.41699 13.6694 1.38351 13.5884C1.35004 13.5074 1.33288 13.4206 1.33301 13.333V2.667C1.33301 2.4901 1.40328 2.32045 1.52837 2.19536C1.65346 2.07027 1.82311 2 2.00001 2ZM13.333 7.333H2.66601V12.667H13.333V7.333ZM13.333 6V3.333H2.66601V6H13.333ZM6.00001 4H7.33301V5.333H6.00001V4ZM3.33301 4H4.66601V5.333H3.33301V4Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3723_88419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowModal);
export default __webpack_public_path__ + "static/media/show-modal.98211d95637648a24ee4eb379ec5594c.svg";
export { ForwardRef as ReactComponent };